import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ClientTemplateService } from '../services/client-template.service';
import { DynamicTemplateConfigService } from '../services/pdf-generation/dynamic-template-config.service';
import { LayoutComponent } from './layout/layout.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LayoutComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'pos-ui';

  constructor(
    private clientTemplateService: ClientTemplateService,
    private dynamicTemplateConfigService: DynamicTemplateConfigService
  ) { }

  ngOnInit() {
    // Load client templates on app initialization if user is logged in
    this.loadClientTemplates();
  }

  private loadClientTemplates() {
    const clientIdStr = localStorage.getItem('client_id');
    if (clientIdStr) {
      try {
        const clientId = JSON.parse(clientIdStr);
        // console.log('Loading client templates for client_id:', clientId);

        // Preload client sale data (business logo, signature, bank details, terms & conditions)
        this.dynamicTemplateConfigService.loadClientSaleData(clientId).subscribe();

        this.clientTemplateService.getClientTemplates(clientId).subscribe({
          next: (templates) => {
            // console.log('Client templates loaded successfully:', templates);
            const defaultTemplate = this.clientTemplateService.getDefaultTemplate();
            if (defaultTemplate) {
              //   console.log('Default template set:', defaultTemplate);

              // Preload dynamic template configuration if template_id >= 8
              if (defaultTemplate.template_id >= 8) { // nandhini change 8 to 9
                //   console.log('Default template is dynamic (template_id >= 8), preloading configuration...');
                this.dynamicTemplateConfigService.preloadTemplateConfig(clientId).subscribe({
                  next: (config) => {
                    if (config) {
                      console.log('Dynamic template configuration preloaded successfully');
                    } else {
                      console.warn('Failed to preload dynamic template configuration');
                    }
                  },
                  error: (error) => {
                    console.error('Error preloading dynamic template configuration:', error);
                  }
                });
              }
            }
          },
          error: (error) => {
            console.error('Error loading client templates:', error);
          }
        });
      } catch (error) {
        console.error('Error parsing client_id from localStorage:', error);
      }
    } else {
      console.log('No client_id found in localStorage. Templates will be loaded after login.');
    }
  }
}
